// src/price.ts
function priceToDBFormat(price) {
  return Math.round(price * 1e3);
}
function priceFromDBFormat(price) {
  return price / 1e3;
}

export {
  priceToDBFormat,
  priceFromDBFormat
};
